import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import type React from "react";

import { zinc } from "./tokens";

/** Bordered panel title bar; renders a close button only when `onClose` is provided. */
export default function PanelHeader({
  children,
  onClose,
  height,
}: {
  children: React.ReactNode;
  onClose?: () => void;
  height?: string | number;
}) {
  return (
    <Box
      sx={{
        bgcolor: zinc[800],
        px: 2,
        height,
        display: "flex",
        alignItems: "center",
        borderRadius: 1.5,
        border: `1px solid ${zinc[400]}`,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      {onClose && (
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: zinc[400],
            "&:hover": { color: "white", bgcolor: zinc[700] },
            ml: 1,
          }}
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
      )}
    </Box>
  );
}
